export default "__VITE_ASSET__vIOUiFAe__"